export default `p.xz=abs(.5-mod(p.xz,1.))+.01;
    float DEfactor=1.;
    escape = 0.;
    for (int i=0; i<14; i++) {
      p = abs(p)-vec3(0.,2.,0.);  
      float r2 = dot(p, p);
      float sc=2./clamp(r2,0.4,1.);
      p*=sc; 
      DEfactor*=sc;
      p = p - vec3(0.1,1.2,0.5);
      escape += exp(-0.2*dot(p,p));
    }
    return length(p)/DEfactor-.0005;
  }`